import { render, staticRenderFns } from "./FilesCompanyContracts.vue?vue&type=template&id=1584d18a"
import script from "./FilesCompanyContracts.vue?vue&type=script&lang=js"
export * from "./FilesCompanyContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports